module.exports = __webpack_public_path__ + "img/pdv-manager.74f19d9e.svg";